import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { getUUID } from "../services/api";
// import { getToken } from "../services/cookies";

const Footer = ({ type, uuid }) => {
  const navigate = useNavigate();


  return (
    <div className="fixed  bottom-0 left-0 w-full flex justify-center items-end z-50">
      <div className="relative w-full max-w-2xl mx-auto">
        {/* Footer arka planı */}
        <div
          className={`${
            type === 1 ? "bg-white" : "bg-[#fff]"
          } px-16 pr-12 rounded-t-3xl h-[58px]  flex justify-between items-center shadow-lg relative z-10`}
        >
          {/* Sol ikon */}
          <div
            onClick={() =>
              navigate("/"+uuid+"/store")
            }
            className="flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity"
          >
            <img
              src="/assets/icons/shopping.png"
              alt="Mağaza"
              className="w-8 h-8 object-contain"
            />
          </div>
          {/* Sağ ikon */}
          <div
            onClick={() =>
              navigate("/"+uuid+"/settings")
            }
            className="flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity"
          >
            <img
              src="/assets/icons/user.png"
              alt="Ayarlar"
              className="w-8 h-8 object-contain"
            />
          </div>
        </div>
        {/* Ortadaki öne çıkan buton */}
        <div className="absolute left-1/2 -top-6 transform border-[6px] rounded-full border-white -translate-x-1/2 z-20">
          <div
            onClick={() =>
              navigate("/"+uuid+"/module-list")
            }
            className={`${
              type === 1 ? " border-[#A2E0E9]" : "border-[#A2E0E9]"
            }  border-[6px] bg-[#5ABCC8] w-[60px] h-[60px] rounded-full flex items-center justify-center shadow-2xl cursor-pointer hover:scale-105 transition-transform`}
          >
            <img
              src="/assets/icons/J.png"
              alt="Ana Sayfa"
              className="w-7 h-7 object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
